import * as React from 'react';
import { Button, message } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { DownloadOutlined } from '@ant-design/icons';
import { useApiMutation } from 'client/core/network/hooks/useApiMutation';
import { RequestApi } from 'client/components/schema/requests/RequestApi';
import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';
import { resolveApiPath } from 'client/core/appConfig';
import { isEmpty } from 'lodash';

export interface IWidgetPreviewDownloaderProps extends ButtonProps {
  buttonText: string | undefined;
  procedureId: number;
  documentId?: number;
}

/**
 * Pulsante per il download del documento pdf della domanda, generato
 * come "anteprima" in modo che l'utente possa:
 * - Visionarlo
 * - Ricaricarlo firmato
 */
export function WidgetPreviewDownloader(props: IWidgetPreviewDownloaderProps) {
  const { buttonText, procedureId, documentId, ...buttonProps } = props;

  const compileContext = useRequestCompileContext();
  const [generate, generateState] = useApiMutation(
    RequestApi.preview.generate,
    { data: { procedureId } }
  );

  const handleGenerate = async (e: any) => {
    try {
      if (!documentId) {
        message.warning(`Nessun documento assegnato`);
        return;
      }

      const result = await generate({
        // Passiamo i valori del form corrente
        data: { input: compileContext.request, documentId }
      });

      // Avvio il download
      let a = document.createElement('a');
      a.setAttribute('target', '_blank');
      a.href = resolveApiPath(
        `/procedures/${procedureId}/requests/preview/${documentId}/${result.data.fileToken}`
      );

      a.click();
    } catch (e) {
      message.error(`Si è verificato un errore durante la preparazione del documento, si prega di riprovare.`); // prettier-ignore
      console.error(e);
    }
  };

  return (
    <Button
      block
      size="large"
      type="primary"
      ghost
      icon={<DownloadOutlined />}
      loading={generateState.loading}
      {...buttonProps}
      onClick={handleGenerate}
      disabled={!documentId}
    >
      {generateState.loading
        ? 'Preparo il documento...'
        : isEmpty(buttonText)
        ? 'Scarica il Modulo'
        : buttonText}
    </Button>
  );
}
